import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  THEME03: {
    path: `${baseRoutes.userBaseRoutes}theme03`,
  },
};

export default accessRoute;
